import React, { MouseEventHandler } from 'react';

type Props = {
  title: string;
  description: string;
  buttonTitle: string;
  onButtonPress: MouseEventHandler<HTMLButtonElement>;
};

export function BCACard({ title, description, buttonTitle, onButtonPress }: Props) {
  return (
    <section className="flex flex-col gap-6">
      <div className="flex flex-col gap-4">
        <p className="text-4xl">{title}</p>
        <p className="text-xl">{description}</p>
      </div>

      <button className="bg-red-600 w-fit px-10 py-2 rounded-full" onClick={onButtonPress}>
        {buttonTitle}
      </button>
    </section>
  );
}
